import React from 'react'
import Skeleton from 'react-loading-skeleton'

import styles from './DocumentCreate.module.scss'

export const DocumentCreateSkeleton = () => {
  return (
    <div className={styles.root}>
      <div className={styles.rows}>
        <Skeleton className={styles.input} />
        <Skeleton className={styles.input} />
        <Skeleton className={styles.input} />
        <Skeleton className={styles.input} />
        <Skeleton className={styles.input} />
        <div className={styles.btns}>
          <Skeleton className={styles.btn} />
          <Skeleton className={styles.btn} />
        </div>
      </div>
      <div className={styles.template}>
        <Skeleton className={styles.string} />
        <Skeleton className={styles.string} />
        <Skeleton className={styles.string} />
        <Skeleton className={styles.string} />
        <Skeleton className={styles.string} />
      </div>
    </div>
  )
}
